export default "__VITE_ASSET__ChyETvCK__"